<template>
  <div>
    <b-row>
      <b-col cols="12">
        <cumulatives-filter :get-report-data="getReport" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col cols="12">
          <primary-heading title-text="Genel Toplam" />
          <b-row>
            <b-col
              cols="12"
              md="3"
            >
              <default-card
                title="Satış Adet"
                :value="reportData.grandTotals.sales_count"
                icon="BarChartIcon"
                color="primary"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <default-card
                title="Trafik Oranı"
                prefix="%"
                :value="reportData.grandTotals.trafik_percent"
                icon="PercentIcon"
                color="primary"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <default-card
                title="Kasko Oranı"
                prefix="%"
                :value="reportData.grandTotals.kasko_percent"
                icon="PercentIcon"
                color="primary"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <default-card
                title="Marka Kasko Oranı"
                prefix="%"
                :value="reportData.grandTotals.marka_kasko_percent"
                icon="PercentIcon"
                color="primary"
              />
            </b-col>
            <b-col cols="12">
              <area-charts-spline
                :labels-data="reportData.chartData.categories"
                :series-data="reportData.chartData.series"
                title-text="Sigorta Sıfır Satış"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-for="(item,index) in reportData.data"
          :key="'item_' + index"
          cols="12"
        >
          <b-row :key="'brand_' + index">
            <b-col cols="12">
              <primary-heading
                :title-text="item.brand"
                title-class="text-secondary"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <default-card
                title="Satış Adet"
                :value="item.sales_count"
                icon="BarChartIcon"
                color="info"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <default-card
                title="Trafik Oranı"
                prefix="%"
                :value="item.trafik_percent"
                icon="PercentIcon"
                color="info"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <default-card
                title="Kasko Oranı"
                prefix="%"
                :value="item.kasko_percent"
                icon="PercentIcon"
                color="info"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <default-card
                title="Marka Kasko Oranı"
                prefix="%"
                :value="item.marka_kasko_percent"
                icon="PercentIcon"
                color="info"
              />
            </b-col>
          </b-row>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import PrimaryHeading from '@/layouts/components/PrimaryHeading.vue'
import CumulativesFilter from '@/views/Insurance/FilterCards/CumulativesFilter.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import AreaChartsSpline from '@/layouts/components/ReportCharts/AreaChartsSpline.vue'

export default {
  name: 'SalesCumulativesInsurance',
  components: {
    AreaChartsSpline,
    LoadingCard,
    BRow,
    BCol,
    PrimaryHeading,
    DefaultCard,
    CumulativesFilter,
  },
  computed: {
    reportData() {
      return this.$store.getters['insuranceSalesReports/reportData']
    },
    cumulativesParams() {
      return this.$store.getters['insuranceSalesReports/cumulativesParams']
    },
    loading() {
      return this.$store.getters['insuranceSalesReports/loading']
    },
  },
  created() {
    this.getReport()
  },
  methods: {
    getReport() {
      this.$store.dispatch('insuranceSalesReports/getReportData', this.cumulativesParams)
    },
  },
}
</script>
